import React from 'react';

/**
 * Placeholder shown while a mission list loads. It mirrors what replaces it —
 * a section header, then cards with the same frame — so nothing jumps when the
 * real rows arrive.
 */
const MissionListSkeleton = ({ rows = 3 }) => (
  <div
    data-testid="mission-list-skeleton"
    aria-hidden="true"
    className={'animate-pulse'}
  >
    <div
      data-skeleton-header
      className={'flex items-center gap-3 py-2'}
    >
      <div className={'w-8 h-8 bg-gray-200 rounded-lg flex-shrink-0'} />
      <div className={'h-3 w-28 bg-gray-200 rounded'} />
      <div className={'ml-auto h-4 w-6 bg-gray-100 rounded'} />
    </div>
    {Array.from({ length: rows }).map((_, index) => (
      <div
        key={index}
        data-skeleton-card
        className={'border border-[#efefef] rounded-md p-3 mb-3'}
      >
        <div className={'flex justify-between gap-3'}>
          <div className={'flex flex-col gap-2 flex-1 min-w-0'}>
            <div className={'h-4 w-2/3 bg-gray-200 rounded'} />
            <div className={'h-3 w-1/3 bg-gray-100 rounded'} />
          </div>
          <div className={'flex flex-col items-end gap-2 flex-shrink-0'}>
            <div className={'h-4 w-20 bg-gray-200 rounded'} />
            <div className={'h-3 w-28 bg-gray-100 rounded'} />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default MissionListSkeleton;
